import { z } from "zod";

/**
 * The warehouse an instance loads into (`destination_type`, platform 0001). Its own module so
 * both `./tenants` (a tenant's set-up names one for its first instances) and `./instancesAdmin`
 * read it without importing each other.
 */
export const destinationTypeSchema = z.enum(["snowflake", "databricks"]);
export type DestinationType = z.infer<typeof destinationTypeSchema>;
